<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles productionTask">
            <van-nav-bar
                title="生产任务"
                left-text="订单下发"
                left-arrow
                @click-left="onClickLeft"
            ></van-nav-bar>
            <section class="showFontBtn" :class="{'readOnly': !isReadOnly}">
                <van-collapse v-model="activeNames">
                    <van-collapse-item name="1">
                        <div slot="title" class="title">
                            <i class="iconfont icondingdan"></i>基础信息
                        </div>
                        <van-cell
                            :value="orderDetailsData.task_number"
                            title="任务编号"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.order_number"
                            title="订单编号"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.contract_number"
                            title="合同编号"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.start_time"
                            title="计划日期"
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.arrival_time"
                            title="要求到货日期"
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.contract_typename"
                            title="合同类型"
                            :icon="require('@/assets/images/icons/icon_gy_5.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.employee_name"
                            title="业务员"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.employee_phone"
                            title="业务员电话"
                            :icon="require('@/assets/images/icons/icon_4.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.xclxr"
                            title="现场联系人"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.xclxr_phone"
                            title="现场联系人电话"
                            :icon="require('@/assets/images/icons/icon_4.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.customer_name"
                            title="客户名称"
                            :icon="require('@/assets/images/icons/icon_gy_8.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.project_name"
                            title="工程名称"
                            :icon="require('@/assets/images/icons/icon_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.project_address"
                            title="工程地址"
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.station_name"
                            title="供货站点"
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.plan_quantity"
                            title="计划方量"
                            :icon="require('@/assets/images/icons/icon_30.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.quantity"
                            title="任务放量"
                            :icon="require('@/assets/images/icons/icon_30.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.strength_grade_name"
                            title="强度等级"
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.special_require_name"
                            title="附加型号"
                            :icon="require('@/assets/images/icons/icon_21.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.pouring_name"
                            title="浇筑方式"
                            :icon="require('@/assets/images/icons/icon_32.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.place_detail"
                            title="施工部位描述"
                            :icon="require('@/assets/images/icons/icon_gy_4.png')"
                        ></van-cell>
                        <van-cell
                            :value="orderDetailsData.remarks"
                            title="备注"
                            :icon="require('@/assets/images/icons/icon_gy_4.png')"
                        ></van-cell>
                    </van-collapse-item>
                </van-collapse>
            </section>
            <footer class="commonFormBtns" v-if="isReadOnly">
                <van-button type="info" @click="orderConfirm">
                    订单下发
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
export default {
    // 订单详情
    name: 'production-task',
    components: {},
    props: {},
    data() {
        return {
            activeNames: ['1'],
            // 订单详情数据
            orderDetailsData: {},
            // 是否是只读
            isReadOnly: false,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.orderDetailsData = this.$route.query.data;
        if (this.orderDetailsData.distributed_status === 0) {
            this.isReadOnly = true;
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 订单下发
        orderConfirm() {
            this.$axios
                .put('/interfaceApi/production/producttask/distributed/' + this.orderDetailsData.task_number)
                .then(() => {
                    this.$router.isBack = 1;
                    this.$toast.success('下发成功!');
                    this.$router.push({ name: 'orderIssue', params: { isRefreshList: true } });
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus">
.productionTask
    height 100%
    section
        height calc(100% - 90rpx)
        margin-bottom 5rpx
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        &.readOnly
            height calc(100% - 45rpx)
    .van-icon
        .van-icon__image
            width 16rpx
            height 16rpx
            margin-top 3rpx
            margin-right 5rpx
    .van-collapse
        &:after
            display none
    .van-cell__title
        width 100rpx
        font-size 18rpx
        line-height 24rpx
        color #061F3E
        .iconfont
            font-size 18rpx
            margin-right 5rpx
    .van-collapse-item__content
        .van-cell__title
            font-size 16rpx
    .title
        font-size 17rpx
        color #3495FB
    .van-collapse-item__content
        padding 0
    .van-field__control,
    .van-cell__value
        color #979EA7
        &::placeholder
            color #D7D7D7 !important
    .textarea
        position relative
        &:before
            position absolute
            top 20rpx
            left 26rpx
        textarea
            text-indent 30rpx
            &.van-field__control
                border 1px solid #D7D7D7
                border-radius 4px
                padding 10rpx
                height 130rpx !important
</style>
